export default __webpack_public_path__ + "static/media/m_use_action_cz.cb8022e8.png";